import React, { Component } from "react";
import AnchorLink from "react-anchor-link-smooth-scroll";
import { Link } from "react-router-dom";
import "./style.css";

export default class MobileMenu extends Component {
  state = {
    isMenuShow: false,
  };

  menuHandler = () => {
    this.setState({
      isMenuShow: !this.state.isMenuShow,
    });
  };

  render() {
    const { isMenuShow } = this.state;

    return (
      <div>
        <div className={`mobileMenu ${isMenuShow ? "show" : ""}`}>
          <div className="close" onClick={this.menuHandler}>
            <i className="fa fa-close"></i>
          </div>
          <div className="logo2">
            <h2>
              <Link to="/">Hanh & Phương</Link>
            </h2>
          </div>
          <ul className="responsivemenu">
            <li>
              <AnchorLink href="#couple">Chúng mình</AnchorLink>
            </li>
            <li>
              <AnchorLink href="#story">Chuyện tình</AnchorLink>
            </li>
            <li>
              <AnchorLink href="#journey">Kệ sách hành trình</AnchorLink>
            </li>
            <li>
              <AnchorLink href="#gallery">Kỷ niệm</AnchorLink>
            </li>
            <li>
              <AnchorLink href="#rsvp">Sổ lưu bút</AnchorLink>
            </li>
          </ul>
        </div>

        <div className="showmenu" onClick={this.menuHandler}>
          <i className="fa fa-bars" aria-hidden="true"></i>
        </div>
      </div>
    );
  }
}
